import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./App.css"
import './utils/flexible'
import './utils/rem'
import api from './api'
import request from './utils/request'
import bannerImg from './components/bannerImg'
import autoDirective from './plugins/autoDirective'

Vue.use(autoDirective)
//api
Vue.prototype.$api = api
Vue.component('banner-img', bannerImg)
//轮播
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

//iVew库
import iView from 'iview';
import 'iview/dist/styles/iview.css';  
Vue.use(iView);

//element库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI)

router.beforeEach((to, from, next) => {
let getFlag = localStorage.getItem("Flag");
  if(getFlag === "isLogin"){
    store.state.isLogin = true
    next()
  }else{
    next()
  }
});

router.afterEach(route => {
  window.scroll(0, 0);
});

import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
return routerPush.call(this, location).catch(error=> error)
}

Vue.config.productionTip = false
const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
